import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable camelcase */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, useUrlParams, Dropdown, useUser } from 'components';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ReportRequestTableHeader = function ReportRequestTableHeader(_ref) {
  var getData = _ref.getData,
      franchisesList = _ref.franchisesList;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var office = urlQueryParams.office,
      franchisee = urlQueryParams.franchisee;
  var queryParams = useRef(urlQueryParams);
  useEffect(function () {
    getData(queryParams.current);
  }, []);

  var handleOfficeChange = function handleOfficeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      office: value
    });
    getData(queryParams.current);
  };

  var handleFranchiseeChange = function handleFranchiseeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      franchisee: value
    });
    getData(queryParams.current);
  };

  return ___EmotionJSX("section", {
    css: tableHeaderContainer
  }, ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8
  }, (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant) && ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041A\u0440. \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A",
    displayKey: "name",
    uniqueKey: "id",
    value: franchisee,
    options: franchisesList,
    onChange: handleFranchiseeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ((roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isFranchiseeOwner) || (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isOfficeManager)) && ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041E\u0444\u0438\u0441",
    displayKey: "name",
    uniqueKey: "id",
    value: office,
    options: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.offices,
    onChange: handleOfficeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  }))));
};

ReportRequestTableHeader.propTypes = {
  getData: PropTypes.func,
  franchisesList: PropTypes.array
};
export default ReportRequestTableHeader;